//@flow
import React from "react";
// $FlowFixMe
import css from "./listenagain.module.scss";
import EpisodeList from "./episodelist";
import Episode from "./episode";
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// import {faArrowCircleDown, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import placeholder from "../../img/icon/idr-icon-id-yellow.svg";

// type Props = {
//   onClick: Function,
//   displayEpisodes: boolean,
//   show: Object,
// };

const Show = (props: Object): Object => {
  const { show, onClick, displayEpisodes } = props;
  // console.log(this.props.show.sponsor);
  if (!show) return null;
  const episodes = show.episodes?.map((episode, i) => {
    return <Episode key={i} episode={episode} feature={show} />;
  });

  if (episodes?.length === 0) return null;

  const showImage = show.image ? show.image : placeholder;

  return (
    <div className={css.showWrapper}>
      <div className={css.show} onClick={onClick}>
        <div
          className={css.showTile}
          // style={{
          //   backgroundImage: `url(${showImage})`,
          // }}
        >
          <img src={showImage} alt={show.name} />
        </div>

        <div className={css.showDetails} style={{ borderColor: show?.station?.color }}>
          <div className={css.top}>
            <div className={css.showTitle}>{show.name}</div>
            <div className={css.showDescription}>{show.description}</div>
          </div>
          {show.sponsor.name ? (
            <span
              className={css.sponsor}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open(show.sponsor.url, "_blank", "location=yes,height=900,width=1200,scrollbars=yes,status=yes");
              }}
            >
              <div>
                <div className={css.sponsorAssoc}>In association with</div>
                <div className={css.sponsorInfo}>
                  <img className={css.sponsorImage} src={show.sponsor.image} alt={show.sponsor.name} />
                  {/* <div className={css.sponsorName}>{show.sponsor.name}</div> */}
                </div>
              </div>
            </span>
          ) : null}
          <div className={css.bottom}>
            <div className={css.episodeCount}>
              {episodes?.length}
              &nbsp;episode
              {episodes?.length === 1 ? null : "s"}&nbsp;
              <i className="fa fa-chevron-circle-right" />
            </div>
          </div>
        </div>
      </div>
      <EpisodeList display={displayEpisodes} showtag={show.tag}>
        {episodes}
      </EpisodeList>
    </div>
  );
};

export default Show;
